<template>
  <auth-frame>
    <div v-if="isLoading" class="flex justify-center py-6">
      <loader-circle-icon class="size-8 animate-spin text-primary" />
    </div>

    <div v-else-if="errorMessage" class="flex flex-col items-center gap-4 text-center">
      <frown-icon class="size-12 text-muted-foreground" />
      <h1 class="m-0 text-xl font-semibold text-foreground">{{ tr('Authentication failed') }}</h1>
      <p class="m-0 text-sm text-muted-foreground">{{ errorMessage }}</p>
    </div>
  </auth-frame>
</template>

<script>
import { Frown, LoaderCircle } from '@lucide/vue';

import ShoprenterService from '@/services/Shoprenter';
import AuthFrame from '@/ui/components/AuthFrame.vue';

export default {
  name: 'ShoprenterAuthView',
  components: {
    AuthFrame,
    FrownIcon: Frown,
    LoaderCircleIcon: LoaderCircle,
  },
  data: () => ({
    isLoading: true,
    errorMessage: null,
  }),
  created() {
    this.authenticate();
  },
  methods: {
    authenticate() {
      const { shopname, code, timestamp, hmac, to } = this.$route.query;

      ShoprenterService.auth({ shopname, code, timestamp, hmac })
        .then(resp => {
          this.$store.commit('auth/setToken', resp.access_token);
          this.$store.commit('auth/setUser', resp.user);

          if (this.$route.query.shoprenter_charge === 'failed') {
            this.$router.replace('/settings?shoprenter_charge=failed');
          }
          else if (this.$route.query.shoprenter_charge === 'success') {
            this.$router.replace('/dashboard?shoprenter_charge=success');
          }
          else {
            this.$router.replace('/' + (to || 'dashboard'));
          }

          return resp;
        })
        .catch(err => {
          this.isLoading = false;
          this.errorMessage = err.message || this.tr('An unexpected error occurred. Please contact support.');
        });
    },
  },
};
</script>
